import React from 'react';
import './assets/styles/global.css'
import Landing from './pages/landing';

function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App;
